import { useCallback } from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { ProgressReportTableContent } from '../table/ProgressReportTable'
import { getProjectPlanPath } from '../../../../../lib/functions/projectPlan'
import store from '../../../../../store'
import { addGlobalMessage, MessageLevel } from '../../../../../store/messages'
import { intl } from '../../../../../i18n'
import { DiscussionTargetType } from '../../../../../domain/entity/DiscussionEntity'
import '../../../../../styles/agGrid.scss'

type ScopeRowNumberCellRendererProps =
  ICellRendererParams<ProgressReportTableContent> & {
    /** 行が工程かチケット管理表か。移り先が無いときに出す警告の文言を、これで振り分ける */
    targetType?: DiscussionTargetType
  }

export const ScopeRowNumberCellRenderer = ({
  data,
  value,
  targetType,
}: ScopeRowNumberCellRendererProps) => {
  const processUuid = data?.uuid

  const handleClick = useCallback(
    async (e: React.MouseEvent) => {
      e.stopPropagation()
      if (!processUuid) return

      const projectCode = store.getState().project.current?.code
      if (!projectCode) return

      try {
        await getProjectPlanPath(processUuid)
        const url = `${window.location.origin}/projectPlan/${projectCode}?treeRootUuid=${processUuid}`
        window.open(url, '_blank')
      } catch {
        store.dispatch(
          addGlobalMessage({
            type: MessageLevel.WARN,
            title: intl.formatMessage({
              id:
                targetType === 'TICKET_LIST'
                  ? 'versionReport.progressReport.ticketListNotFound'
                  : 'versionReport.progressReport.process.notFound',
            }),
          })
        )
      }
    },
    [processUuid, targetType]
  )

  return (
    <div className="sevend-ag-cell-sequence-no">
      {processUuid ? (
        <a className="sevend-ag-cell-sequence-no__link" onClick={handleClick}>
          {value}
        </a>
      ) : (
        <p className="sevend-ag-cell-sequence-no__label">{value}</p>
      )}
    </div>
  )
}
